import { CurrencyFormat, formatDate } from "../../../../components/helpers";
import IsEmpty from "../../../../components/helpers/IsEmpty";

export const convertListVoucher = (data) => {
    let converted = [];

    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            key: index + 1,
            voucherId: item.id,
            gadaiId: item.gadai_id,
            installmentId: item.gadai_installment_id,
            dateCreated: formatDate(item.created_at),
            name: item.voucher_name,
            sbg: item.sbg_code,
            receipt: item.receipt_code || '-',
            customerName: item.ktp_name,
            discountAmount: `Rp ${CurrencyFormat(item.voucher_amount)}`,
            amount: item.voucher_amount,
            dateUsed: IsEmpty(item.used_date) ? 'Belum digunanakan' : formatDate(item.used_date)
        });
    });
    return converted;
};